import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { Form, notification, Popconfirm, Button as Antdbutton } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import IActions from 'icons/IActions';

import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  getOfferPricingAttributeList,
  ParOfferPricingAttributeResponse,
  removeOfferPricingAttribute,
} from 'services/pricing';
import ButtonOperation from 'components/ButtonOperation';
import PricingAttributeModal from './offerPricingAttributeModal';
import ModalControllerNV from 'components/ModalControllerNV';
import DeleteButton from 'components/DeleteButton';
import TasksListPopover from 'pages/workflow/TasksListPopover';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { toCurrency } from 'utils/utils';

const NEW_PRICING_COMMISSION_ID = -1;

type AttirbuteTableProps = {
  objectid: number;
  objecttype: string;
  currcode: string;
  isMyProfile?: boolean;
  brokerDetail?:any
};

const PricingAttirbuteTable = (props: AttirbuteTableProps) => {
  const { objectid, objecttype, currcode, brokerDetail } = props;
  const [form] = Form.useForm();
  const fieldName = 'pricing';
  const [visibleCatalogItemDetails, setVisibleCatalogItemDetails] =
    useState(false);
  

  const { data, refetch, isFetching } = useQuery(
    ['getOfferPricingAttributeList', objectid, objecttype],
    () =>
      getOfferPricingAttributeList({
        objectid: objectid,
        objecttype: objecttype,
      }).then((res) => res.list || [])
  );

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'attid',
        width: 70,
        fixed: 'left',
      },
      {
        dataIndex: 'attlabel',
        width: 250,
        fixed: 'left',
        render: (_value, _record, index) => (
          <ModalControllerNV
            modal={({ setVisible, visible }) => (
              <PricingAttributeModal
                objectid={objectid}
                objecttype={objecttype}
                refetch={refetch}
                attid={_record.attid}
                offerPricing={_record}
                offerPricinglabel={_record.attcodelabel}
                visible={visible}
                onCancel={() => {
                  setVisible(false);
                }}
                currcode={currcode}
                record={brokerDetail}
              />
            )}
            content={({ setVisible, visible }) => (
              <a
                onClick={() => {
                  setVisible(true);
               
                }}
              >
                {_value}
              </a>
            )}
          />
        ),
      },
      {
        dataIndex: 'atttypelabel',
        width: 180,
        fixed: 'left',
      },
      {
        dataIndex: 'attmethodlabel',
        width: 180,
        fixed: 'left',
      },
      {
        dataIndex: 'attcodelabel',
        width: 200,
        fixed: 'left',
        render: (_value, _record, index) => (
          <ModalControllerNV
            modal={({ setVisible, visible }) => (
              <PricingAttributeModal
                objectid={objectid}
                objecttype={objecttype}
                refetch={refetch}
                attid={_record.attid}
                offerPricing={_record}
                offerPricinglabel={_record.attcodelabel}
                visible={visible}
                onCancel={() => {
                  setVisible(false);
                }}
                currcode={currcode}
                record={brokerDetail}
              />
            )}
            content={({ setVisible, visible }) => (
              <a
                onClick={() => {
                  setVisible(true);
               
                }}
              >
                {_value}
              </a>
            )}
          />
        ),
      },
      {
        dataIndex: 'attamountmethodlabel',
        width: 180,
      },
      {
        dataIndex: 'attdirection',
        width: 240,
      },
      {
        dataIndex: 'attcoefdefault',
        width: 200,
      },
      {
        dataIndex: 'attamountdefault',
        width: 180,
      },
      {
        dataIndex: 'attamountmax',
        width: 100,
      },
      {
        dataIndex: 'attrate',
        width: 100,
      },

      {
        dataIndex: 'tprole',
        width: 100,
      },
      {
        dataIndex: 'tprefrerence',
        width: 100,
      },

      {
        dataIndex: 'requesttype',
        width: 100,
      },
      {
        dataIndex: 'requestreceiverid',
        width: 100,
      },
      {
        dataIndex: 'requestreceiverroleprofile',
        width: 100,
      },
      {
        dataIndex: 'requestreceivertype',
        width: 100,
      },
      {
        dataIndex: 'proccodelabel',
        width: 100,
      },

      {
        dataIndex: 'tasklabel',
        width: 100,
      },
      {
        dataIndex: 'attbudget',
        width: 100,
        fixed: 'right',
        render:toCurrency,
      },
      {
        dataIndex: 'attbudgetbooked',
        width: 100,
        fixed: 'right',
        render:toCurrency,
      },

      {
        dataIndex: 'attbudgetused',
        width: 100,
        fixed: 'right',
        render:toCurrency,
      },
      {
        dataIndex: 'startdate',
        width: 100,
        fixed: 'right',
      },
      {
        dataIndex: 'enddate',
        width: 100,
        fixed: 'right',
      },

      {
        dataIndex: 'statuslabel',
        width: 100,
        fixed: 'right',
      },

      {
        key: 'actions',
        render: (_, record) => (
          <>
            <TasksListPopover
              entityId={record.attid}
              entityName="PRATTRIB"
              entityReference={record.attcode}
              status={record?.attstatus ?? ''}
              statusdate={record?.attstatusdate ?? ''}
              onClose={refetch}
            >
              <Antdbutton
                size="small"
                icon={<IActions height="15px" width="15px" />}
              >
                <GetLabel label="actions" />
              </Antdbutton>
            </TasksListPopover>
            {record.status === 'INIT' && (
              <Popconfirm
                title="Sure to delete?"
                onConfirm={() => {
                  removeOfferPricingAttribute({
                    attid: record?.attid,
                  }).then((res) => {
                    notification.success({ message: res.message });
                    refetch();
                  });
                }}
              >
                <DeleteButton onlyIcon />
              </Popconfirm>
            )}
          </>
        ),
        width: 80,
        fixed: 'right',
      },
    ],
    [form, objectid, refetch]
  );

  return (
    <Form form={form} initialValues={INITIAL_VALUES}>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const pricing: ParOfferPricingAttributeResponse[] =
            getFieldValue(fieldName);
          return (
            <DataGrid
              rowKey="attid"
              columns={columns}
              dataSource={data}
              isLoading={isFetching}
              titleComcode="pricingattribute"
              hideFilters
              extraActions={
                <ModalControllerNV
                  modal={({ setVisible, visible }) => (
                    <PricingAttributeModal
                      isNew
                      currcode={currcode}
                      objectid={objectid}
                      objecttype={objecttype}
                      refetch={refetch}
                      offerPricinglabel={<GetLabel label='brokerAttributesModal' />}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                      record={brokerDetail}
                      
                    />
                  )}
                  content={({ setVisible, visible }) => (
                    <ButtonOperation
                      type="primary"
                      icon={<PlusOutlined />}
                      comcode="add"
                      onClick={() => setVisible(true)}
                    />
                  )}
                />
              }
            />
          );
        }}
      </Form.Item>
    </Form>
  );
};

const INITIAL_VALUES = {
  pricing: [],
};

export default PricingAttirbuteTable;
